import { render, staticRenderFns } from "./FormImagemProductComponent.vue?vue&type=template&id=b24db82e&scoped=true&"
import script from "./FormImagemProductComponent.vue?vue&type=script&lang=js&"
export * from "./FormImagemProductComponent.vue?vue&type=script&lang=js&"
import style0 from "./FormImagemProductComponent.vue?vue&type=style&index=0&id=b24db82e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24db82e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VFlex,VForm,VIcon,VLayout})
